/* src/app/webtree-website/talent-insights-free-trial-banner/talent-insights-free-trial-banner.component.scss */
.spacer {
  height: 90px;
}
.webbtree-banner-container {
  position: relative;
  width: 100%;
  height: auto;
}
.webbtree-banner-container .webbtree-banner {
  background-image: url("./media/V2_Webbtree_Talent_Discovery_Free_trial_16-V3AMIJR2.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
}
.webbtree-banner-container .webbtree-banner .pt-130 {
  padding-top: 130px;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container {
  background-color: #ffffff;
  width: 90%;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul {
  width: 100%;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul li {
  width: 50%;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul li button {
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  color: #969696;
  background-color: #ffffff;
  border: solid 0.5px #d9d9d9;
  height: 40px;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul li button.active {
  background-color: #e4f1f3;
  color: #2e93a1;
  border: solid 0.5px #2e93a1;
  background-color: #e4f1f3;
  font-size: 14px;
  font-weight: 500;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul li:first-child button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container ul li:last-child button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content {
  padding: 20px;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .wc-form-control {
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  width: 100% !important;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .btn-get-talent-insight {
  padding: 12px 24px;
  border-radius: 4px;
  background-image:
    linear-gradient(
      253deg,
      #c845ab,
      #e24e7f);
  color: #ffffff;
  outline: none;
  border: 0;
  font-size: 16px;
  font-weight: 600;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .ats-dropBtn button {
  outline: none;
  border: 1px solid #d6dde6;
  background-color: #fff;
  width: 100%;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  margin: 0px;
  padding: 6px 12px;
  height: 36px;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .ats-dropBtn .dropdown-toggle::after {
  border-top: 0;
  display: none;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .ats-dropBtn + input.wc-form-control {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content .ats-dropBtn .dropdown-menu.show {
  padding: 15px;
}
.webbtree-banner-container .webbtree-banner .mini-tab-container .tab-content input.mat-chip-input {
  margin: 0;
}
.webbtree-banner-container .webbtree-banner .xs-slider-container {
  display: none;
}
.webbtree-banner-container .webbtree-banner h1.f-36 {
  font-size: 36px;
}
@media screen and (max-width: 912px) {
  .webbtree-banner-container .webbtree-banner .pt-130 {
    padding-top: 40px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile {
    flex-direction: column-reverse;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 br {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 + p.col-md-11 {
    margin: 0 auto;
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .mini-tab-container {
    width: 100%;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 + p {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container {
    display: block;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container p {
    text-align: center;
  }
}
@media screen and (max-width: 768px) {
  .webbtree-banner-container .webbtree-banner .pt-130 {
    padding-top: 40px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile {
    flex-direction: column-reverse;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 br {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 + p.col-md-11 {
    margin: 0 auto;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1.f-36 {
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .mini-tab-container {
    width: 100%;
    margin-bottom: 30px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 + p {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container {
    display: block;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container p {
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner h2.f-30 {
    font-size: 24px !important;
  }
}
@media screen and (max-width: 640px) {
  .webbtree-banner-container .webbtree-banner .pt-130 {
    padding-top: 40px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile {
    flex-direction: column-reverse;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 br {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1 + p.col-md-11 {
    margin: 0 auto;
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 h1.f-36 {
    text-align: center;
    font-size: 28px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .mini-tab-container {
    width: 100%;
    margin-bottom: 30px;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 #container3 + p {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container {
    display: block;
  }
  .webbtree-banner-container .webbtree-banner .sm-mobile .col-md-6 .xs-slider-container p {
    text-align: center;
  }
}
@media screen and (max-width: 480px) {
  .webbtree-banner-container .webbtree-banner h1.f-36 {
    text-align: center;
    font-size: 28px;
  }
  .webbtree-banner-container .webbtree-banner p.f-16 {
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner p.f-16 br {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner p.f-14 {
    display: none;
  }
  .webbtree-banner-container .webbtree-banner p.continentdropdown {
    display: block;
  }
  .webbtree-banner-container .webbtree-banner .pt-130 {
    padding-top: 60px;
  }
  .webbtree-banner-container .webbtree-banner .mini-tab-container {
    width: 100%;
    margin-bottom: 100px;
  }
  .webbtree-banner-container .webbtree-banner .mini-tab-container ul {
    width: 100%;
  }
  .webbtree-banner-container .webbtree-banner .mini-tab-container ul li {
    width: 50%;
  }
  .webbtree-banner-container .webbtree-banner .mini-tab-container ul li button {
    width: 100%;
    font-weight: 500;
    font-size: 14px;
    color: #969696;
    background-color: #ffffff;
    border: solid 1px #d9d9d9;
    height: 40px;
    padding: 0.5rem 0.5rem;
  }
  .webbtree-banner-container .webbtree-banner .mini-tab-container ul li button.active {
    background-color: #e4f1f3;
    color: #2e93a1;
    border: solid 0.5px #2e93a1;
    background-color: #e4f1f3;
    font-size: 14px;
    font-weight: 500;
  }
  .webbtree-banner-container .webbtree-banner .xs-slider-container {
    display: block;
  }
  .webbtree-banner-container .webbtree-banner .xs-slider-container p.f-14 {
    display: flex;
    text-align: center;
  }
  .webbtree-banner-container .webbtree-banner div.spacer {
    height: 60px;
  }
  .webbtree-banner-container .webbtree-banner div.spacer:last-child {
    display: none;
  }
}
.free-access-tiles {
  position: relative;
  width: calc(33% - 13px);
  height: 260px;
  padding: 16px;
  margin: 0 16px 16px 0;
  border-radius: 8px;
  border: 1px solid #8ad8fd;
  font-size: 16px;
  font-weight: 500;
  color: #484b59;
  text-align: center;
}
.free-access-tiles .mb40px {
  margin-bottom: 16%;
}
.free-access-tiles .onhover-layer {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.85);
  border-radius: 8px;
  display: none;
  transition: display 1.5s linear;
}
.free-access-tiles .onhover-layer button {
  padding: 8px 16px;
  border-radius: 2px;
  background-color: #ffeb37;
  color: #484b59;
  outline: none;
  border: 0;
  cursor: pointer;
}
.free-access-tiles:hover .onhover-layer {
  display: flex;
}
@media screen and (max-width: 912px) {
  .free-access-tiles {
    width: calc(50% - 8px);
  }
  .free-access-tiles:nth-child(2) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(4) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(6) {
    margin-right: 0;
  }
}
@media screen and (max-width: 768px) {
  .free-access-tiles {
    width: calc(50% - 8px);
  }
  .free-access-tiles:nth-child(2) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(4) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(6) {
    margin-right: 0;
  }
}
@media screen and (max-width: 640px) {
  .free-access-tiles {
    width: calc(50% - 8px);
    height: 226px;
  }
  .free-access-tiles:nth-child(2) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(4) {
    margin-right: 0;
  }
  .free-access-tiles:nth-child(6) {
    margin-right: 0;
  }
}
@media screen and (max-width: 480px) {
  .free-access-tiles {
    width: 100%;
    margin-right: 0px;
    height: 260px;
  }
}
.free-access-tiles.bgimg1 {
  background-image: url("./media/Analyze-diverity-insights1-4HZQBFYP.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.free-access-tiles.bgimg2 {
  background-image: url("./media/Track-talent-movement1-5HY5SXY7.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.free-access-tiles.bgimg3 {
  background-image: url("./media/Discover-top-skills-and-titles1-5QUT5BKG.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.free-access-tiles.bgimg4 {
  background-image: url("./media/Leverage-seniority-and-nationality-insights1-2ZEONBZ7.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.free-access-tiles.bgimg5 {
  background-image: url("./media/tgtcdt11-RDDIIJM7.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.free-access-tiles.bgimg6 {
  background-image: url("./media/Access-profiles-with-contact1-PY47D6JT.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left bottom;
}
.region-box {
  width: 102px;
  height: 55px;
  border-radius: 4px;
  overflow: hidden;
}
.border-blue {
  border: 2px solid #2e93a1;
}
.border-gray {
  border: 1px solid #cacaca;
}
.ats-upload-btn {
  width: 100%;
  border: solid 0.5px #b0bed2;
  color: #484b59;
  display: flex;
  box-sizing: border-box;
  position: relative;
  background: #e4f1f3;
  border-radius: 8px;
}
#container3,
#container2 {
  height: 35px;
  position: relative;
  overflow: hidden;
  margin-top: 40px;
  margin-bottom: 40px;
}
@media screen and (max-width: 480px) {
  #container3 {
    display: none;
  }
}
.photobanner {
  position: absolute;
  top: 0px;
  left: 0px;
  overflow: hidden;
  white-space: nowrap;
  animation: bannermove 16s linear infinite;
}
.photobanner img {
  margin: 0 0.5em;
  height: 35px;
}
@keyframes bannermove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(-50%, 0);
  }
}
.generate_loader {
  height: 24px;
  flex-grow: 0;
  background-image:
    linear-gradient(
      253deg,
      #c845ab 85%,
      #e24e7f 48%);
  font-size: 16px;
  font-weight: 600;
  text-align: center !important;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.img-success {
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
}
.green-color {
  color: #2E93A1;
}
.btn-trms-small-regular {
  padding: 6px 20px;
  margin: 0 auto;
}
.inputWidth {
  width: 75%;
  margin-right: 10px;
}
.inputWidth.ai-source-input {
  width: 69%;
}
.free-trail2 {
  padding: 6px 10px !important;
}
.testimonyCardContainer {
  display: flex;
  flex-wrap: wrap;
}
.testimonyCard {
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  margin-left: 15px;
  width: calc(33.33% - 15px);
}
.testimonyCard .logoHeader {
  background-color: #f9f8f5;
  padding: 20px;
  text-align: center;
  border-radius: 8px;
  text-align: center;
  border-bottom: 1px solid #f9f8f5;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.testimonyCard .logoHeader .logo {
  width: 150px;
  height: 150px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  overflow: hidden;
}
.testimonyCard .logoHeader .logo img {
  width: 100%;
  height: auto;
}
.testimonyCard .testimonyContent {
  padding: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: #484b59;
}
.testimonyCard .testimonyContent p {
  width: 100%;
  margin-bottom: 0;
}
.testimonyCard .testimonyContent p.f-16.font-weight-600 {
  font-weight: 600;
  text-align: left;
}
.testimonyCard .testimonyContent p.f-16.font-weight-500 {
  font-weight: 500;
  text-align: left;
}
@media only screen and (max-width: 640px) {
  .testimonyCard {
    width: calc(100% - 35px);
    margin-bottom: 30px;
  }
}
.testimonyFooter {
  margin-top: auto;
  text-align: left;
  padding: 20px;
  display: flex;
}
.testimonyFooter p {
  text-align: left;
  width: 100%;
}
.testimonyFooter p {
  width: 100%;
}
.testimonyFooter p.f-16.font-weight-600 {
  font-weight: 600;
  text-align: left;
  font-size: 14px;
}
.testimonyFooter p.f-16.font-weight-500 {
  font-weight: 500;
  text-align: left;
  margin-bottom: 0 !important;
  font-size: 14px;
}
.testimonyFooter .profile-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.testimonyFooter .profile-image img {
  width: 100%;
  height: auto;
}
.card-data-content {
  height: calc(100% - 200px);
}
.trial2header {
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 100% 120% !important;
  height: 100%;
  padding: 27px 40px;
}
.submit-button-spin {
  width: 23%;
}
.ai-source-button {
  width: 31%;
}
@media only screen and (max-width: 640px) {
  .inputwithbutton {
    flex-direction: column;
  }
  .inputwithbutton .inputWidth {
    width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
  }
  .submit-button-spin {
    width: 100%;
  }
}
.imgWidth50 {
  width: 55%;
}
@media only screen and (max-width: 640px) {
  .imgWidth50 {
    width: 100%;
  }
}
.section3 h2 {
  font-size: 24px;
  font-weight: 500;
  color: #484b59;
  line-height: 1.5;
  margin-bottom: 10px;
}
.section3 h2 + p {
  font-size: 14px;
  color: #484b59;
  line-height: 1.6;
  font-weight: normal;
  margin-bottom: 15px;
}
.section3 .datacount {
  width: 20%;
}
.section3 .datacount div {
  width: 80%;
  position: relative;
}
.section3 .datacount div span {
  font-size: 45px;
  color: #2e93a1;
  line-height: 1;
  display: flex;
  margin-bottom: 5px;
  font-weight: 600;
}
.section3 .datacount div p {
  color: #484b59;
  font-size: 12px;
  font-weight: 500;
}
.section3 .datacount div::after {
  content: "";
  position: absolute;
  display: flex;
  height: 30px;
  width: 2px;
  background-color: #d9d9d9;
  top: 28px;
  right: 0;
}
.section3 .datacount:last-child div {
  width: 90%;
}
.section3 .datacount:last-child div:last-child::after {
  display: none;
}
@media only screen and (max-width: 640px) {
  .section3 h2 {
    font-size: 24px;
  }
  .section3 div.d-flex {
    flex-direction: column;
  }
  .section3 .datacount {
    width: 100%;
    margin-bottom: 40px;
  }
  .section3 .datacount div {
    width: 100%;
  }
  .section3 .datacount div::after {
    display: none;
  }
  .section3 .datacount:last-child div {
    width: 100%;
  }
  .section3 .datacount:last-child div:last-child::after {
    display: none;
  }
}
@media only screen and (max-width: 640px) {
  .xs-min-height {
    height: 40px;
  }
}
/*# sourceMappingURL=talent-insights-free-trial-banner.component-ZGNOQRDJ.css.map */
